__turbopack_context__.v({
  "applyModal": "MembershipComponent-module__mR0SjW__applyModal",
  "ctaRow": "MembershipComponent-module__mR0SjW__ctaRow",
  "memCta": "MembershipComponent-module__mR0SjW__memCta",
  "memCtaPrimary": "MembershipComponent-module__mR0SjW__memCtaPrimary",
  "memCtaSecondary": "MembershipComponent-module__mR0SjW__memCtaSecondary",
  "root": "MembershipComponent-module__mR0SjW__root",
  "typeformContainer": "MembershipComponent-module__mR0SjW__typeformContainer",
});
